module.exports = __webpack_public_path__ + "static/media/european_union.871ae2e7.svg";